export enum EntityParameterType {
  ProviderType = 'ProviderType',
  CaqhLoginInfo = 'CaqhLoginInfo',
  ProviderSsn = 'Ssn',
  ProviderNpi = 'Npi',
  ProviderNccpaBoardCertificateInfo = 'NccpaBoardCertificateInfo',
  ProviderName = 'Name',
  ProviderLicense = 'License',
  ProviderGender = 'Gender',
  ProviderEducation = 'Education',
  ProviderDea = 'Dea',
  ProviderDateOfBirth = 'DateOfBirth',
  ProviderCertificate = 'Certificate',
  ProviderCaqhId = 'CaqhId',
  ProviderBoardCertificationNumber = 'BoardCertificationNumber',
  ProviderAddress = 'Address',
  FacilityName = 'FacilityName',
  FacilityAccreditationInfo = 'FacilityAccreditationInfo',
  FacilityCmsCertificationInfo = 'FacilityCmsCertificationInfo'
}

export const EntityParameterTypeLabel: Record<EntityParameterType, string> = {
  [EntityParameterType.ProviderName]: 'Name',
  [EntityParameterType.ProviderNpi]: 'NPI',
  [EntityParameterType.ProviderDateOfBirth]: 'DOB',
  [EntityParameterType.ProviderSsn]: 'SSN',
  [EntityParameterType.ProviderLicense]: 'License',
  [EntityParameterType.ProviderAddress]: 'Address',
  [EntityParameterType.ProviderEducation]: 'Education',
  [EntityParameterType.ProviderBoardCertificationNumber]: 'Board Certification Number',
  [EntityParameterType.ProviderCertificate]: 'Certificate',
  [EntityParameterType.ProviderType]: 'Provider Type',
  [EntityParameterType.ProviderNccpaBoardCertificateInfo]: 'Board Certification (NCCPA Only)',
  [EntityParameterType.ProviderGender]: 'Gender',
  [EntityParameterType.FacilityName]: 'Facility Name',
  [EntityParameterType.ProviderDea]: 'DEA',
  [EntityParameterType.ProviderCaqhId]: 'CAQH ID',
  [EntityParameterType.FacilityAccreditationInfo]: 'Facility Accreditation Info',
  [EntityParameterType.FacilityCmsCertificationInfo]: 'Facility CMS Certification Info',
  [EntityParameterType.CaqhLoginInfo]: 'CAQH Login Info'
};
